import React from 'react'

import Layout from '../components/Layout'
import Text from '../components/Text'
import Button from '../components/Button'
import ActionBar from '../components/ActionBar'
import BackButton from '../components/BackButton'

const Conditions = ({ conditions, onSetConditions, onNext, onBack }) => {
  const onSelectCondition = condition => {
    onSetConditions({
      ...conditions,
      ...condition
    })
  }

  const onSelect = disease => {
    const diseases = conditions.diseases || []

    if (diseases.includes(disease)) {
      return onSelectCondition({
        diseases: diseases.filter(d => d !== disease)
      })
    }

    onSelectCondition({
      diseases: [...diseases, disease]
    })
  }

  const renderPhase = () => {
    if (conditions.smoking === undefined) {
      return (
        <Layout key="smokes">
          <Layout>
            <Text large>Do you smoke?</Text>
          </Layout>

          <Layout>
            <Button onClick={() => onSelectCondition({ smoking: true })} fullWidth>
              Yes
            </Button>

            <Button onClick={() => onSelectCondition({ smoking: false })} fullWidth>
              No
            </Button>
          </Layout>
        </Layout>
      )
    }

    if (conditions.contact === undefined) {
      return (
        <Layout fade key="contact">
          <Layout>
            <Text large>Have you had close contact with a confirmed COVID case?</Text>
          </Layout>

          <Layout>
            <Text>
              <ul>
                <li>Living in the same apartment</li>
                <li>Direct, physical contact (touching, shaking hands, kissing, body fluids)</li>
                <li>Face-to-face contact, or within 1.5 meters, for longer than 15 minutes</li>
              </ul>
            </Text>
          </Layout>

          <Layout>
            <Button onClick={() => onSelectCondition({ contact: true })} fullWidth>
              Yes
            </Button>

            <Button onClick={() => onSelectCondition({ contact: false })} fullWidth>
              No
            </Button>
          </Layout>
        </Layout>
      )
    }

    return (
      <Layout fade key="diseases">
        <Layout>
          <Text large>
            Please select if you been diagnosed with any of the following conditions
          </Text>
        </Layout>

        <Layout>
          <Button
            onClick={() => onSelect('lungs')}
            selected={conditions.diseases && conditions.diseases.includes('lungs')}
            fullWidth
          >
            Chronic lung disease
          </Button>

          <Button
            onClick={() => onSelect('diabetes')}
            selected={conditions.diseases && conditions.diseases.includes('diabetes')}
            fullWidth
          >
            Diabetes
          </Button>

          <Button
            onClick={() => onSelect('heart')}
            selected={conditions.diseases && conditions.diseases.includes('heart')}
            fullWidth
          >
            Heart disease
          </Button>

          <Button
            onClick={() => onSelect('obesity')}
            selected={conditions.diseases && conditions.diseases.includes('obesity')}
            fullWidth
          >
            Obesity / Adipositas
          </Button>
        </Layout>
      </Layout>
    )
  }

  return (
    <>
      {renderPhase()}

      <ActionBar active={conditions}>
        <BackButton onClick={onBack} />
        <Button onClick={onNext} disabled={conditions.contact === undefined}>
          Next
        </Button>
      </ActionBar>
    </>
  )
}

export default Conditions
